import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Components
import Layout from './components/Layout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Organization from './pages/Organization';
import DeviceMonitoring from './pages/DeviceMonitoring';
import User from './pages/User';
import Devices from './pages/Devices';
import Account from './pages/Account';
import FirmWare from './pages/FirmWare';
import './style.css';
import { useStateValue } from './ContextApi/StateProvider';
import Events from './pages/Events';

const App = () => {
  const [{ user }, dispatch] = useStateValue();
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={user ? <Dashboard /> : <Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/organization" element={<Organization />} />
          <Route path="/users" element={<User />} />
          <Route path="/device-monitoring" element={<DeviceMonitoring />} />
          <Route path="/inventory" element={<Devices />} />
          <Route path="/firmware" element={<FirmWare />} />
          <Route path="/account" element={<Account />} />
          <Route path="/events" element={<Events />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
